import { Trophy } from "lucide-react";

function Row({ r }) {
  return (
    <li
      data-testid={r.is_you ? "leaderboard-you" : `leaderboard-row-${r.rank}`}
      className={`flex items-center gap-3 py-2 px-3 rounded-xl ${r.is_you ? "bg-[#D4AF37]/15 border border-[#D4AF37]/40" : ""}`}
    >
      <span className={`w-6 text-center font-display ${r.rank <= 3 ? "gold-text" : "text-[#A7B0C0]"}`}>{r.rank}</span>
      <span className="flex-1 text-starlight">{r.is_you ? `${r.name} (you)` : r.name}</span>
      <span className="text-sm text-[#A7B0C0]">{r.count} invite{r.count === 1 ? "" : "s"}</span>
    </li>
  );
}

export default function Leaderboard({ data }) {
  if (!data) return null;
  return (
    <div data-testid="referral-leaderboard" className="mt-4 pt-4 border-t border-[#D4AF37]/15">
      <p className="flex items-center gap-2 text-[11px] uppercase tracking-[0.3em] gold-text mb-2">
        <Trophy size={13} /> Top Stargazers
      </p>
      <ol className="space-y-0.5">
        {data.top.map((r) => <Row key={r.rank} r={r} />)}
      </ol>
      {data.you && (
        <ol className="mt-1 pt-1 border-t border-dashed border-[#D4AF37]/15">
          <Row r={data.you} />
        </ol>
      )}
    </div>
  );
}
